export interface WkCompareRequestModel {
  source: string;
  versions: string[];
}
